import { HTMLAttributes, ReactNode } from 'react';
import classnames from 'src/util/classnames';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  color?: string;
  pill?: boolean;
  children?: ReactNode;
}

export function Badge({ color, pill, className, children, ...props }: BadgeProps) {
  return (
    <span className={classnames('badge', color && `bg-${color}`, pill && 'rounded-pill', className)} {...props}>
      {children}
    </span>
  );
}
